import { render, staticRenderFns } from "./InvestmentCategories.vue?vue&type=template&id=645a9572&scoped=true&"
import script from "./InvestmentCategories.vue?vue&type=script&lang=js&"
export * from "./InvestmentCategories.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentCategories.vue?vue&type=style&index=0&id=645a9572&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645a9572",
  null
  
)

export default component.exports